import React from 'react';
import './style.css';

const Footer = () => {
  return (
    <footer>
      <div className="footer center">
        <p>© 2022 Óticas Vida - Todos os direitos reservados. - Dev. by <a href="https://dithan.github.io" target='_blank'>Thiago Rocha</a></p>
      </div>
    </footer>
  );
};

export default Footer;
